<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item :link="{ name: 'Aktuálne dáta', icon: 'dashboard', path: '/infosite' }">
        </sidebar-item>
        <sidebar-item :link="{ name: 'Kalkulačka', icon: 'calculate', path: '/calculator' }">
        </sidebar-item>
        <sidebar-item :link="{ name: 'Schéma', icon: 'settings_ethernet', path: '/schema' }">
        </sidebar-item>
        <sidebar-item :link="{ name: 'Teplotné senzory', icon: 'image' }">
          <sidebar-item
            v-for="sensor in sensors.filter(s => s.type === 'temperature')"
            :key="sensor.path"
            :link="{
              name: sensor.name,
              icon: 'dashboard',
              path: sensor.path,
            }"
          />
        </sidebar-item>
        <sidebar-item :link="{ name: 'Merače energií', icon: 'image' }">
          <sidebar-item
            v-for="sensor in sensors.filter(s => s.type === 'energy')"
            :key="sensor.path"
            :link="{
              name: sensor.name,
              icon: 'dashboard',
              path: sensor.path,
            }"
          />
        </sidebar-item>
        <sidebar-item :link="{ name: 'Merače objemu', icon: 'image' }">
          <sidebar-item
            v-for="sensor in sensors.filter(s => s.type === 'water')"
            :key="sensor.path"
            :link="{
              name: sensor.name,
              icon: 'dashboard',
              path: sensor.path,
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Odhlásiť', icon: 'exit_to_app', path: '/login' }"
          @click.native="handleLogout"
        />
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { customers, sellers, sensors } from "@/utils/userInfo";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    //ContentFooter, potom na stránke: <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    //FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
  },
  data() {
    return {
      sidebarBackgroundColor: "white",
      sidebarBackground: "green",
      sidebarBackgroundImage: "",
      sidebarMini: false,
      sidebarImg: false,
      customers: customers,
      sellers: sellers,
      sensors: sensors,
    };
  },
  methods: {
    handleLogout() {
      this.$store.commit("logout");
      this.$router.push("/login");
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
